export default __webpack_public_path__ + "macbook_sm@2x.5af241d5.png";